import sendEventTracking from '../Events/sendEventTracking';

export default class PromotionTracking {
  private trackingAttribute: string;

  private viewProcessed: string;

  private trackingPromotionList: NodeListOf<HTMLElement>;

  private observer: IntersectionObserver;

  create(
    dataLayer: any,
    trackingAttribute: string,
    viewProcessed: string,
    trackingPromotionList: NodeListOf<HTMLElement>
  ): IntersectionObserver {
    this.trackingAttribute = trackingAttribute;
    this.viewProcessed = viewProcessed;
    this.trackingPromotionList = trackingPromotionList;
    this.elementInViewport(dataLayer);
    this.elementClick(dataLayer);

    return this.observer;
  }

  /*
   * Add Intersection Observer for Promotion element
   */
  private elementInViewport(dataLayer: any) {
    this.observer = new IntersectionObserver(
      (elements: IntersectionObserverEntry[]) => {
        elements.forEach((promotionElement: IntersectionObserverEntry) => {
          if (
            promotionElement.target instanceof HTMLElement &&
            promotionElement.isIntersecting
          ) {
            const promotionInViewport = promotionElement.target;
            const {
              trackingCreativeName,
              trackingPromotionName,
              trackingCreativeSlot,
              trackingItemId,
              trackingItemName,
            } = promotionInViewport.dataset;

            if (!promotionInViewport.classList.contains(this.viewProcessed)) {
              promotionInViewport.classList.add(this.viewProcessed);

              sendEventTracking({
                event: 'view_promotion',
                dataLayer,
                ecommerce: {
                  creative_name: trackingCreativeName,
                  creative_slot: trackingCreativeSlot,
                  promotion_name: trackingPromotionName,
                  items: [
                    {
                      item_id: trackingItemId,
                      item_name: trackingItemName,
                    },
                  ],
                },
              });
            }
          }
        });
      }
    );

    this.trackingPromotionList.forEach((promotionElement: HTMLElement) => {
      this.observer.observe(promotionElement);
    });
  }

  /*
   * Add click event to tracking elements
   */
  private elementClick(dataLayer: any) {
    document.addEventListener(
      'click',
      (event) => {
        if (event.target instanceof HTMLElement) {
          const currentElement: HTMLElement = event.target;

          // Add slide event
          if (
            currentElement.hasAttribute(this.trackingAttribute) ||
            currentElement.closest(`[${this.trackingAttribute}]`)
          ) {
            let trackingElement: HTMLElement = currentElement;
            if (!trackingElement.hasAttribute(this.trackingAttribute)) {
              trackingElement = currentElement.closest(
                `[${this.trackingAttribute}]`
              );
            }

            // Once click event to element
            if (
              !trackingElement.classList.contains(
                'js-selectPromotion--processed'
              )
            ) {
              const {
                trackingCreativeName,
                trackingPromotionName,
                trackingCreativeSlot,
                trackingItemId,
                trackingItemName,
              } = trackingElement.dataset;

              trackingElement.classList.add('js-selectPromotion--processed');

              sendEventTracking({
                event: 'select_promotion',
                dataLayer,
                ecommerce: {
                  creative_name: trackingCreativeName,
                  creative_slot: trackingCreativeSlot,
                  promotion_name: trackingPromotionName,
                  items: [
                    {
                      item_id: trackingItemId,
                      item_name: trackingItemName,
                    },
                  ],
                },
              });
            }
          }
        }
      },
      { passive: true }
    );
  }
}
